import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import "./index.css";
import App from "./App";
import { bootstrap } from "./bootstrap";
import { ConfigProvider } from "./js/core/configProvider";
import { config } from "./js/baseConf";

const root = ReactDOM.createRoot(document.getElementById("root"));

bootstrap().then(() => {
  root.render(
    <React.StrictMode>
      <ConfigProvider config={config}>
        <App />
      </ConfigProvider>
    </React.StrictMode>
  );
});
